import { Component, HostListener, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { AppSettings } from "src/app/app.settings";
import { ApiSevicesService } from "src/app/shared/services/api-sevices.service";
import { ToastrService } from "ngx-toastr";
import { Settings } from "../../app.settings.model";
import { FileDowloadService } from "src/app/shared/services/file-dowload.service";
import { PagerModule } from "src/app/shared/constants/pages.const";
import { ConfirmationComponent } from "src/app/shared/component/confirmation/confirmation.component";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {
  public settings: Settings;
  formData: FormData | null = null;
  page: any = PagerModule;
  constructor(
    public dialog: MatDialog,
    public appSettings: AppSettings,
    public api: ApiSevicesService,
    private toast: ToastrService,
    private fileDownload: FileDowloadService
  ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    setTimeout(() => {
      this.getRegisterList();
    }, 0);
  }

  @HostListener("dragover", ["$event"]) onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("dragleave", ["$event"]) onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener("drop", ["$event"]) onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    const fileList = event.dataTransfer?.files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.storeFileInFormData(file);
    }
  }

  onFileChange(event: Event) {
    const fileList = (event.target as HTMLInputElement).files;
    if (fileList && fileList.length > 0) {
      const file = fileList[0];
      this.storeFileInFormData(file);
    }
  }

  private storeFileInFormData(file: File) {
    this.formData = new FormData();
    this.formData.append("file", file);
    this.settings.loadingSpinner = true;
    this.api.createRegister(this.formData).subscribe({
      next: (res: any) => {
        this.toast.success(res.message);
        this.getRegisterList();
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  public displayedColumns: string[] = [
    "id",
    "fileName",
    "totalRecords",
    "registerRecords",
    // "totalRollbacks",
    "created_at",
    "status",
    "action",
  ];
  public dataSource: any;

  getRegisterList() {
    this.settings.loadingSpinner = true;
    this.api.getRegister(this.page).subscribe({
      next: (res: any) => {
        this.dataSource = res.data;
        this.page = res.pager;
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  refresh() {
    this.getRegisterList();
  }

  deleteFile(id: number, name: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        filename: name,
        title: "Delete",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.settings.loadingSpinner = true;
        this.api.deleteRegister(id).subscribe({
          next: (res: any) => {
            this.toast.success(res.message);
            this.getRegisterList();
          },
          error: (error) => {
            this.toast.error(error.error.message);
            this.settings.loadingSpinner = false;
          },
        });
      }
    });
  }

  downloadFile(id: number, name: string) {
    this.settings.loadingSpinner = true;
    this.api.downloadRegister(id).subscribe({
      next: (res) => {
        this.fileDownload.downloadFIle(res, name);
        this.toast.success("File Download Succefull.");
        this.settings.loadingSpinner = false;
      },
      error: (error) => {
        this.toast.error(error.error.message);
        this.settings.loadingSpinner = false;
      },
    });
  }

  rollback(id: number, name: string) {
    const dialogRef = this.dialog.open(ConfirmationComponent, {
      data: {
        filename: name,
        title: "Rollback",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.settings.loadingSpinner = true;
        const data = { file_id: id };
        this.api.rollbackRegister(data).subscribe({
          next: (res: any) => {
            this.toast.success(res.message);
            this.getRegisterList();
          },
          error: (error) => {
            this.toast.error(error.error.message);
            this.settings.loadingSpinner = false;
          },
        });
      }
    });
  }

  pageChange(e: any) {
    this.page.limit = e.pageSize;
    this.page.page = e.pageIndex + 1;
    this.getRegisterList();
  }
}
